export default __webpack_public_path__ + "static/media/mars23.7ed6af0a.gif";